module.exports = __webpack_public_path__ + "media/public/images/about/description/partner2-0135cb9320bf4f42e893f2172b259729.png";